import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import HomepageLayout from './home/HomepageLayout';
import createLoadableComponent from './common/LoadableComponent';
import LoadingPageLayout from './loading/LoadingPageLayout';
import PageNotFoundLayout from './page-not-found/PageNotFoundLayout';
// import ServicesLayout from './services/ServicesLayout';
// import ContactUsLayout from './contact/ContactUsLayout';
// import AboutUsLayout from './about/AboutUsLayout';
// import TeamLayout from './team/TeamLayout';
// import InvestLayout from './invest/InvestLayout';
// import PressLayout from './press/PressLayout';
// import HowProductsWorkLayout from './how-products-work/HowProductsWorkLayout';
// import SocialWallLayout from './social-wall/SocialWallLayout';
// import LoadableFaq from './faq/LoadableFaq';
// import LoadableCommitment from './commitment/LoadableCommitment';
// import LoadableAbout from './about/LoadableAbout';

const routes = {
  "/services": () => import("./services/ServicesLayout"),
  "/social": () => import("./social/SocialLayout"),
  "/faq": () => import("./faq/FaqLayout"),
  "/contact": () => import("./contact/ContactUsLayout"),
  "/join": () => import("./join/JoinUsLayout"),
  "/about": () => import("./about/AboutUsLayout"),
  "/team": () => import("./team/TeamLayout"),
  "/invest": () => import("./invest/InvestLayout"),
  "/press": () => import("./press/PressLayout"),
  "/terms-of-service": () => import("./legal/TermsOfServicesLayout"),
  "/privacy-policy": () => import("./legal/PrivacyPolicyLayout"),
  "/licenses": () => import("./legal/LicensesLayout"),
  "/how-products-work": () => import("./how-products-work/HowProductsWorkLayout"),
  "/sign-up": () => import("./sign-up/SignUpLayout"),
}

class App extends React.Component {
  public render() {
    return <BrowserRouter>
      <div>
        <Route component={ScrollToTop} />
        <Switch>
          <Route exact path="/" render={q => <HomepageLayout />} />
          {
            Object.keys(routes)
              .map(path => <Route key={path} path={path} component={createLoadableComponent(routes[path])} />)
          }
          <Route path="/loading" render={q => <LoadingPageLayout />} />
          <Route render={q => <PageNotFoundLayout />} />
          {/* <Route path="/services" render={q => <ServicesLayout />} />
              <Route path="/social" render={q => createLoadableComponent(() => import("./social/SocialLayout")) } />
              <Route path="/faq" render={q => <LoadableFaq />} />
              <Route path="/contact" render={q => <ContactUsLayout />} />
              <Route path="/join" render={q => <JoinUsLayout> />} />
              <Route path="/about" render={q => <LoadableAbout />} />
              <Route path="/team" render={q => <TeamLayout />} />
              <Route path="/invest" render={q => <InvestLayout />} />
              <Route path="/press" render={q => <PressLayout />} />
              <Route path="/how-products-work" render={q => <HowProductsWorkLayout />} />
              <Route path="/social" render={q => <SocialLayout />} /> */}
          {/* <Route render={q => <PageNotFoundLayout />} /> */}
        </Switch>
      </div>
    </BrowserRouter>
  }
}

const ScrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
};

export default App;


// WEBPACK FOOTER //
// ./src/App.tsx